import React from "react";

import { Dialog } from "@fronterahealth/frontera-ui-components";

import { EhrSyncAlertsType } from "@api/graphql/types-and-hooks";
import { EhrSyncAlertSection } from "@components/EHRSyncAlert/AlertSection";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  ehrSyncAlerts?: EhrSyncAlertsType | null | undefined;
}

export const EhrSyncAlertPopup: React.FC<Props> = ({ open, setOpen, ehrSyncAlerts }) => {
  return (
    <Dialog
      title="EHR sync issues"
      open={open}
      setOpen={setOpen}
      primaryButton={undefined}
      secondaryButton={undefined}
      showCloseButton={true}
      size="3xl"
    >
      <EhrSyncAlertSection title="Import Issues" alert={ehrSyncAlerts?.importAlert} />
      <EhrSyncAlertSection title="Export Issues" alert={ehrSyncAlerts?.exportAlert} />
    </Dialog>
  );
};
